import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';
import './Card.css';

export type CardPadding = 'none' | 'sm' | 'md' | 'lg';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  /** Aplica hover/cursor — use em cards clicáveis (lista de casos). */
  interactive?: boolean;
}

export function Card({
  padding = 'md',
  interactive = false,
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  return (
    <div
      className={cn(
        'cf-card',
        `cf-card--pad-${padding}`,
        interactive && 'cf-card--interactive',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export interface CardHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Ações no canto direito (botões, toggles). */
  actions?: ReactNode;
}

export function CardHeader({
  title,
  subtitle,
  actions,
  className,
  ...rest
}: CardHeaderProps): JSX.Element {
  return (
    <div className={cn('cf-card__header', className)} {...rest}>
      <div className="cf-card__heading">
        <div className="cf-card__title">{title}</div>
        {subtitle && <p className="cf-card__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="cf-card__actions">{actions}</div>}
    </div>
  );
}
